import { useState, useEffect } from "react";
import LogoAdoraTeam from "./LogoAdoraTeam";
import { GOLD, BLUE } from "../constants/temas";

export default function TelaBoasVindas({ onCriarGrupo, onEntrarGrupo }) {
    const [visivel, setVisivel] = useState(false);
    useEffect(() => { setTimeout(() => setVisivel(true), 80); }, []);

    const card = (delay) => ({
        opacity: visivel ? 1 : 0,
        transform: visivel ? "translateY(0)" : "translateY(28px)",
        transition: `opacity 0.55s ${delay}s ease, transform 0.55s ${delay}s cubic-bezier(.34,1.56,.64,1)`,
    });

    return (
        <div style={{
            minHeight: "100vh", background: BLUE,
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            padding: "32px 20px", boxSizing: "border-box",
            position: "relative", overflow: "hidden"
        }}>
            {/* Fundo decorativo */}
            <div style={{
                position: "absolute", inset: 0, pointerEvents: "none",
                background: `radial-gradient(ellipse 80% 50% at 50% -10%, ${GOLD}18 0%, transparent 70%)`,
            }} />
            <div style={{
                position: "absolute", bottom: -100, right: -80,
                width: 300, height: 300, borderRadius: "50%",
                background: `${GOLD}08`, pointerEvents: "none"
            }} />

            {/* Logo */}
            <div style={{ ...card(0), textAlign: "center", marginBottom: 48 }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <LogoAdoraTeam size={80} glow={true} />
                </div>
                <div style={{ marginTop: 16 }}>
                    <span style={{ fontSize: 34, fontWeight: 900, color: "white", letterSpacing: -1.5 }}>Adora</span>
                    <span style={{ fontSize: 34, fontWeight: 900, color: GOLD, letterSpacing: -1.5 }}>Team</span>
                </div>
                <div style={{ fontSize: 14, color: "#8899bb", marginTop: 6, fontWeight: 500 }}>
                    Sua equipe de louvor em um só lugar
                </div>
            </div>

            {/* Opções */}
            <div style={{ width: "100%", maxWidth: 380, display: "flex", flexDirection: "column", gap: 14 }}>
                {/* Criar grupo */}
                <button onClick={onCriarGrupo} style={{
                    ...card(0.1),
                    padding: "22px 24px", borderRadius: 20,
                    background: `linear-gradient(135deg, ${GOLD}, #FFD166)`,
                    border: "none", cursor: "pointer", textAlign: "left",
                    boxShadow: `0 8px 32px ${GOLD}44`,
                    display: "flex", alignItems: "center", gap: 16
                }}>
                    <div style={{
                        width: 52, height: 52, borderRadius: 16,
                        background: "#0006", display: "flex",
                        alignItems: "center", justifyContent: "center", fontSize: 26, flexShrink: 0
                    }}>👑</div>
                    <div>
                        <div style={{ fontSize: 18, fontWeight: 800, color: BLUE }}>Criar um grupo</div>
                        <div style={{ fontSize: 13, color: "#0f172688", marginTop: 3, fontWeight: 500 }}>
                            Sou líder e quero criar meu ministério
                        </div>
                    </div>
                    <div style={{ marginLeft: "auto", fontSize: 20, color: BLUE }}>→</div>
                </button>

                {/* Entrar com código */}
                <button onClick={onEntrarGrupo} style={{
                    ...card(0.18),
                    padding: "22px 24px", borderRadius: 20,
                    background: "#162040",
                    border: `2px solid #2a3a5e`,
                    cursor: "pointer", textAlign: "left",
                    display: "flex", alignItems: "center", gap: 16
                }}>
                    <div style={{
                        width: 52, height: 52, borderRadius: 16,
                        background: `${GOLD}18`, display: "flex",
                        alignItems: "center", justifyContent: "center", fontSize: 26, flexShrink: 0
                    }}>🎸</div>
                    <div>
                        <div style={{ fontSize: 18, fontWeight: 800, color: "white" }}>Entrar em um grupo</div>
                        <div style={{ fontSize: 13, color: "#8899bb", marginTop: 3, fontWeight: 500 }}>
                            Tenho um código de convite do meu líder
                        </div>
                    </div>
                    <div style={{ marginLeft: "auto", fontSize: 20, color: "#8899bb" }}>→</div>
                </button>

                {/* Já tenho conta */}
                <div style={{ ...card(0.26), textAlign: "center", marginTop: 8 }}>
                    <span style={{ fontSize: 14, color: "#8899bb" }}>Já tem uma conta? </span>
                    <button onClick={onCriarGrupo} style={{
                        background: "none", border: "none",
                        color: GOLD, fontSize: 14, fontWeight: 700,
                        cursor: "pointer", textDecoration: "underline"
                    }}>Entrar</button>
                </div>
            </div>
        </div>
    );
}